import { Form, Input } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { ProjectContext } from "context/ProjectProvider";
import { TFetureDetailUpdateAction } from "entity-app/models";
import { useContext, useEffect, useState } from "react";
import { updatePropertyAtPath } from "utils/utils";

export default function BidPackageEdtableGeneralInfo(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  disabled: boolean;
}) {
  const { featureInstanceData, actions, disabled } = props;
  const {
    columnHeaders: { bidPackageHeaderMap }
  } = useContext(ProjectContext);
  const [localFeatureInstanceData, setLocalFeatureInstanceData] =
    useState<any>();

  useEffect(() => {
    if (!featureInstanceData) return;
    setLocalFeatureInstanceData(structuredClone(featureInstanceData));
  }, [featureInstanceData]);

  return (
    <Form layout="vertical">
      <Form.Item label="Bid Package Description">
        <TextArea
          disabled={disabled}
          value={localFeatureInstanceData?.description}
          rows={5}
          placeholder="Enter Description"
          onBlur={(event: any) => {
            const oldValue = featureInstanceData?.description;
            if (oldValue === event?.target?.value?.trim()) return;
            actions.updateFeatureInstanceFields({
              description: event.target.value?.trim()
            });
            setLocalFeatureInstanceData(
              updatePropertyAtPath(
                localFeatureInstanceData,
                "description",
                event.target.value?.trim()
              )
            );
          }}
          onChange={(event: any) => {
            setLocalFeatureInstanceData(
              updatePropertyAtPath(
                localFeatureInstanceData,
                "description",
                event?.target?.value?.trim()
              )
            );
          }}
        />
      </Form.Item>
      <Form.Item label={bidPackageHeaderMap?.wave}>
        <Input
          disabled={disabled}
          value={localFeatureInstanceData?.feature_bid_package?.wave}
          onChange={(event: any) => {
            setLocalFeatureInstanceData(
              updatePropertyAtPath(
                localFeatureInstanceData,
                "feature_bid_package.wave",
                event?.target?.value?.trim()
              )
            );
          }}
          onBlur={async (event: any) => {
            const oldValue =
              featureInstanceData?.feature_bid_package?.wave?.trim();
            const newValue = event?.target?.value?.trim();
            if (oldValue === newValue) return;
            actions.updateBidPackageFields({
              wave: event.target.value
            });
            setLocalFeatureInstanceData(
              updatePropertyAtPath(
                localFeatureInstanceData,
                "feature_bid_package.wave",
                event?.target?.value?.trim()
              )
            );
          }}
        />
      </Form.Item>
    </Form>
  );
}
